<template>
  <div>
    <div v-if="isReportMode">
      <ReportItemContainer>
        <template #question>{{ question?.text }}</template>
        <template #answer>
          <p>
            <span class="report-item-container__label">Street: </span
            >{{ address.street }}
          </p>
          <p>
            <span class="report-item-container__label">City: </span
            >{{ address.city }}
          </p>
          <p>
            <span class="report-item-container__label">Country: </span
            >{{ address.country }}
          </p>
        </template>
      </ReportItemContainer>
    </div>
    <div v-else>
      <p class="mb-3" v-if="question?.text">
        {{ question?.text }}
      </p>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <p>Address</p>
          <v-text-field
            v-model="address.street"
            @keyup="emitNewAddress"
            variant="outlined"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <p>City</p>
          <v-text-field
            v-model="address.city"
            @keyup="emitNewAddress"
            variant="outlined"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <p>Country</p>
          <PAutocomplete
            :items="itemsStore.countryNames"
            :select-text="address.country"
            placeholder="Select country"
            @field-updated="emitNewACountry"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import Address from "@/models/questions/address";
import { computed, ref } from "vue";
import ReportItemContainer from "@/components/containers/ReportItemContainer.vue";
import type { QuestionModelDto } from "@/models/dto/questionModelDto";
import PAutocomplete from "@/components/custom/PAutocomplete.vue";
import { useItemsStore } from "@/stores/itemsStore";

const props = withDefaults(
  defineProps<{
    questionModel?: QuestionModelDto;
    answer?: object | null;
    isReportMode?: boolean;
  }>(),
  {
    isReportMode: false,
  }
);

const emit = defineEmits<{
  (e: "qEvent", newAddress: Address): void;
}>();

const itemsStore = useItemsStore();

const address = ref((props.answer as Address) ?? new Address());
const question = computed(() => props.questionModel?.question);

function emitNewAddress(): void {
  emit("qEvent", address.value);
}

function emitNewACountry(newCountry: string): void {
  address.value.country = newCountry;
  emitNewAddress();
}
</script>
